const { isArray } = require('./is-array')
const { isNotEmptyObject } = require('./is-not-empty-object')
const { isObject } = require('./is-object')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {*} x
 * @returns {boolean}
 */
function isEmpty (x) {
  if (x === undefined || x === null) {
    return true
  } else if (isArray(x)) {
    return (x.length === 0)
  } else if (isObject(x)) {
    return !isNotEmptyObject(x)
  } else {
    return (x.toString().length === 0)
  }
}

module.exports = { isEmpty }
